import { useMemo } from 'react';

export function useValues(data: Json, field: ITableField) {
  const values: Json = useMemo(() => {
    const { id, mapFields } = field;
    const value = data[id];

    const output: Json = { value };

    if (mapFields) {
      Object.keys(mapFields).forEach((toKey) => {
        const fromKey = mapFields[toKey];
        output[toKey] = data[fromKey];
      });
    }

    return output;
  }, [data, field]);

  return values;
}
